export const tokenize = (text) =>
  String(text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s]/g, ' ')
    .split(/\s+/)
    .filter((token) => token.length > 2);

export const buildTfIdf = (activities) => {
  const documents = (activities || []).map((activity) => ({
    id: activity.id,
    tokens: tokenize(`${activity.nume_activitate} ${activity.descriere || ''}`),
  }));

  const documentFrequency = new Map();
  documents.forEach((document) => {
    new Set(document.tokens).forEach((token) => {
      documentFrequency.set(token, (documentFrequency.get(token) || 0) + 1);
    });
  });

  const total = documents.length || 1;
  const vectors = new Map();
  documents.forEach((document) => {
    const counts = new Map();
    document.tokens.forEach((token) => counts.set(token, (counts.get(token) || 0) + 1));
    const vector = new Map();
    counts.forEach((count, token) => {
      const termFrequency = count / (document.tokens.length || 1);
      const inverseFrequency = Math.log((1 + total) / (1 + (documentFrequency.get(token) || 0))) + 1;
      vector.set(token, termFrequency * inverseFrequency);
    });
    vectors.set(document.id, vector);
  });

  return { vectors, documentFrequency, total };
};

const sparseCosine = (a, b) => {
  if (!a || !b || a.size === 0 || b.size === 0) return 0;
  let dot = 0;
  let normA = 0;
  let normB = 0;
  a.forEach((value, key) => {
    normA += value * value;
    dot += value * (b.get(key) || 0);
  });
  b.forEach((value) => {
    normB += value * value;
  });
  if (normA === 0 || normB === 0) return 0;
  return dot / (Math.sqrt(normA) * Math.sqrt(normB));
};

export const contentScores = (dataset, profile) => {
  const { vectors } = buildTfIdf(dataset.activities);
  const doneKeys = new Set(profile.activityKeys || []);
  const doneNames = new Set(profile.activityNames);

  const doneVectors = dataset.activities
    .filter(
      (activity) =>
        doneKeys.has(`id:${activity.id}`) || doneNames.has(activity.nume_activitate),
    )
    .map((activity) => ({ activity, vector: vectors.get(activity.id) }));

  const scores = new Map();
  dataset.activities.forEach((activity) => {
    if (doneKeys.has(`id:${activity.id}`) || doneNames.has(activity.nume_activitate)) return;
    const candidate = vectors.get(activity.id);
    if (!candidate) return;

    let best = 0;
    let anchor = null;
    doneVectors.forEach((done) => {
      const similarity = sparseCosine(done.vector, candidate);
      if (similarity > best) {
        best = similarity;
        anchor = done.activity;
      }
    });

    if (best > 0) {
      scores.set(activity.id, {
        activityId: activity.id,
        score: Math.min(1, best),
        source: 'content',
        anchorName: anchor?.nume_activitate || null,
        moduleId: activity.id_module,
      });
    }
  });

  return scores;
};
